
import React from 'react';
import { useRoofingBrands } from '@/hooks/useRoofingBrands';
import BrandCard from './BrandCard';
import { Skeleton } from '@/components/ui/skeleton';

const BrandsGrid = () => {
  const { data: brands, isLoading, isError } = useRoofingBrands();

  if (isError) {
    return (
      <div className="text-center py-12">
        <h3 className="text-lg font-medium text-gray-600">
          There was an error loading the brands information. Please try again later.
        </h3>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        {[...Array(6)].map((_, i) => (
          <div key={i} className="flex flex-col space-y-3">
            <Skeleton className="h-20 w-full rounded" />
            <Skeleton className="h-6 w-3/4" />
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-5/6" />
            <Skeleton className="h-4 w-4/6" />
            <Skeleton className="h-10 w-full mt-2" />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      {brands?.map((brand) => (
        <BrandCard key={brand.id} brand={brand} />
      ))}
    </div>
  );
};

export default BrandsGrid;
